export default __webpack_public_path__ + "static/media/course_sections-icon-1.d67597e9.svg";